export const dragTypes = {
  AVAILABLE_FIELD: 'availableField'
};

export const dropPositions = {
  BEFORE: 'BEFORE',
  AFTER: 'AFTER'
};
